import { Compass } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { EmptyState } from '@/components/shared/empty-state';
import { Button } from '@/components/ui/button';

/** Renders inside the shell so the sidebar stays usable while you re-aim. */
export function NotFoundScreen() {
  const { pathname } = useLocation();

  return (
    <EmptyState
      icon={Compass}
      title="Esta dirección no existe"
      description={
        <>
          No encontramos nada en <span className="font-mono text-xs">{pathname}</span>. Puede que el
          enlace esté viejo, o que el módulo esté apagado para tu organización.
        </>
      }
      action={
        <Button asChild>
          <Link to="/">Ir al inicio</Link>
        </Button>
      }
    />
  );
}
